import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";
import {removeEmptyKeys} from "../../../CodingScreen/utils"
import qs from "qs";

export const fetchOutstandingReportData = createAsyncThunk(
  "queue/fetchOutstandingReportData",
  async ({ pageNumber,searchTerm, selectedFilters }, thunkAPI) => {
    //console.log('yes you got',pageNumber,searchTerm,selectedFilters);
    try {
      const cleanedFilters = removeEmptyKeys(selectedFilters);

      const params = { page_number: pageNumber,search_term:searchTerm, ...cleanedFilters };

      const response = await axiosInstance.get("/outstanding_report", {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "repeat" }),
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);


export const fetchFiltersforReport = createAsyncThunk(
  "queue/fetchFiltersforReport",
  async (thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        "/outstanding_report_filter"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchExportToExcelData = createAsyncThunk(
  "queue/fetchExportToExcelData",
  async (params,thunkAPI) => {
     const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => {
        if (Array.isArray(v)) return v.length > 0;
        return v !== undefined && v !== null && v !== "";
      })
    );
    const queryString = new URLSearchParams(cleanParams).toString();
    
    try {
      const response = await axiosInstance.get(
        `/outstanding_report_download?${queryString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
const ReportsSlice = createSlice({
  name: "outstandingreport",
  initialState: {
    outstandingReportTableData: [],
    loadingOutstandingReportTableData: false,
    errorOutstandingReportTableData: null,
    filtersForReport: [],
    loadingFiltersForReport: false,
    errorFiltersForReport: [],
    exportToExcelData:[],
    loadingExportToExcelData:false,
    errorExportToExcelData:null
  },
  extraReducers: (builder) => {
    builder
      // Fetch Queue List
      .addCase(fetchOutstandingReportData.pending, (state) => {
        state.loadingOutstandingReportTableData = true;
        state.errorOutstandingReportTableData = null;
      })
      .addCase(fetchOutstandingReportData.fulfilled, (state, action) => {
        state.loadingOutstandingReportTableData = false;
        state.outstandingReportTableData = action.payload;
      })
      .addCase(fetchOutstandingReportData.rejected, (state, action) => {
        state.loadingOutstandingReportTableData = false;
        state.errorOutstandingReportTableData = action.payload;
      })
      //Fetch filters for Report
      .addCase(fetchFiltersforReport.pending, (state) => {
        state.loadingFiltersForReport = true;
        state.errorFiltersForReport = null;
      })
      .addCase(fetchFiltersforReport.fulfilled, (state, action) => {
        state.loadingFiltersForReport = false;
        state.filtersForReport = action.payload;
      })
      .addCase(fetchFiltersforReport.rejected, (state, action) => {
        state.loadingFiltersForReport = false;
        state.errorFiltersForReport = action.payload;
      })
      //Fetch searchedData for Report
      .addCase(fetchExportToExcelData.pending, (state) => {
        state.loadingExportToExcelData = true;
        state.errorExportToExcelData = null;
      })
      .addCase(fetchExportToExcelData.fulfilled, (state, action) => {
        state.loadingExportToExcelData = false;
        state.exportToExcelData = action.payload;
      })
      .addCase(fetchExportToExcelData.rejected, (state, action) => {
        state.loadingExportToExcelData = false;
        state.errorExportToExcelData = action.payload;
      });
  },
});

export default ReportsSlice.reducer;
